<template>
	<div id="top-bar">
		<img src="../assets/log-asc-top-bar.svg" class="logo" alt="">
		<b-button v-if="isAuthenticated" class="logout cursor-pointer" size="sm" variant="secondary" @click="logout">Salir</b-button>
	</div>
</template>

<script>
import Auth from '../services/Auth';

export default {
	name: 'main-menu',
	methods: {
		logout: function (attribute) {
			Auth.logout();
		}
	},
	computed: {
		isAuthenticated () {
			return this.$store.state.session.isAuthenticated;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TopBar.vue